import { Badge } from "../components/ui/badge";

export function StatusBadge({ status }) {
  const map = {
    // production
    planned: { label: "Geplant", bg: "#e5e5e5", fg: "#171717" },
    in_progress: { label: "In Produktion", bg: "#fef3c7", fg: "#854d0e" },
    completed: { label: "Abgeschlossen", bg: "#d1fae5", fg: "#065f46" },
    cancelled: { label: "Storniert", bg: "#fee2e2", fg: "#991b1b" },
    // delivery
    draft: { label: "Entwurf", bg: "#e5e5e5", fg: "#171717" },
    picked: { label: "Kommissioniert", bg: "#fef3c7", fg: "#854d0e" },
    shipped: { label: "Versendet", bg: "#dbeafe", fg: "#1e3a8a" },
    delivered: { label: "Zugestellt", bg: "#d1fae5", fg: "#065f46" },
    // purchase
    ordered: { label: "Bestellt", bg: "#dbeafe", fg: "#1e3a8a" },
    received: { label: "Erhalten", bg: "#d1fae5", fg: "#065f46" },
    // quality
    pending: { label: "Prüfung", bg: "#fef3c7", fg: "#854d0e" },
    passed: { label: "OK", bg: "#d1fae5", fg: "#065f46" },
    failed: { label: "Sperr", bg: "#fee2e2", fg: "#991b1b" },
    // payment
    open: { label: "Offen", bg: "#e5e5e5", fg: "#171717" },
    paid: { label: "Bezahlt", bg: "#d1fae5", fg: "#065f46" },
    overdue: { label: "Überfällig", bg: "#fee2e2", fg: "#991b1b" },
    partial: { label: "Teilbezahlt", bg: "#fef3c7", fg: "#854d0e" },
    // sales order additional
    confirmed: { label: "Bestätigt", bg: "#dbeafe", fg: "#1e3a8a" },
    in_production: { label: "In Produktion", bg: "#fef3c7", fg: "#854d0e" },
    ready: { label: "Versandbereit", bg: "#d1fae5", fg: "#065f46" },
  };
  const cfg = map[status] || { label: status, bg: "#e5e5e5", fg: "#171717" };
  return (
    <span
      className="pop-pill"
      style={{ background: cfg.bg, color: cfg.fg }}
      data-testid={`status-${status}`}
    >
      {cfg.label}
    </span>
  );
}

export function MhdBadge({ days }) {
  if (days === null || days === undefined) return <span className="text-xs text-[var(--text-muted)]">—</span>;
  let bg = "#d1fae5", fg = "#065f46", label = `${days}T`;
  if (days < 0) { bg = "#fee2e2"; fg = "#991b1b"; label = `abgelaufen`; }
  else if (days <= 7) { bg = "#fee2e2"; fg = "#991b1b"; }
  else if (days <= 30) { bg = "#fef3c7"; fg = "#854d0e"; }
  return (
    <span className="pop-pill" style={{ background: bg, color: fg }}>
      {label}
    </span>
  );
}

export function TypeBadge({ type }) {
  const map = {
    raw: { label: "Rohstoff", bg: "#fffbea", fg: "#854d0e" },
    packaging: { label: "Verpackung", bg: "#dbeafe", fg: "#1e3a8a" },
    finished: { label: "Fertigware", bg: "#d1fae5", fg: "#065f46" },
    bundle: { label: "Bundle", bg: "#fce7f3", fg: "#9d174d" },
    B2B: { label: "B2B", bg: "#e5e5e5", fg: "#171717" },
    B2C: { label: "B2C", bg: "#fef3c7", fg: "#854d0e" },
  };
  const cfg = map[type] || { label: type, bg: "#e5e5e5", fg: "#171717" };
  return (
    <span className="pop-pill" style={{ background: cfg.bg, color: cfg.fg }}>{cfg.label}</span>
  );
}
